import { createModuleStore } from '../utils'
const createInitialFilterState = () => {
  return {
    selectedRoles: [],
    selectedEnterprises: [],
  }
}
export const useUsersStore = createModuleStore(
  'users',
  {
    type: 'User',
    pageHeading: 'Users',
    noHistory: true,
    sortingOn: 'toolbar',
    statusesFilterName: 'statuses',
    uploadOptionsCsv: '',
    uri: '/users',
    serviceUri: '/users',
    listingModuleName: 'AccessControl',
    listingActivityName: 'View User',
    formModuleName: 'AccessControl',
    formActivityName: 'Edit User',
    allFields: [
      {
        key: 'username',
        title: 'USERNAME',
        visible: true,
        sortable: true,
        disabled: true,
      },
      {
        key: 'name',
        title: 'NAME',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'email',
        title: 'EMAIL',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'role',
        title: 'ROLE',
        type: 'role',
        visible: true,
        sortable: false,
        disabled: false,
      },
      {
        key: 'enterprises',
        title: 'ENTERPRISES',
        type: 'enterprises',
        visible: true,
        sortable: false,
        disabled: false,
      },
      {
        key: 'createdBy',
        title: 'CREATED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'createdTimestamp',
        title: 'CREATED TIME',
        type: 'datetime',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedBy',
        title: 'LAST MODIFIED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedTimestamp',
        title: 'LAST MODIFIED TIME',
        type: 'datetime',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'status',
        title: 'STATUS',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'flags',
        title: 'FLAGS',
        customRenderer: 'userFlagsRenderer',
        visible: true,
        sortable: false,
        disabled: true,
      },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
  },
  {
    supportedPageFilters: {
      selectedRoles: {
        type: 'roles',
        multiple: true,
        placeholder: 'Pick one or more roles to filter',
      },
      selectedEnterprises: {
        type: 'enterprises',
        multiple: true,
        placeholder: 'Pick one or more enterprises to filter',
      },
    },
    filters: createInitialFilterState(),
    enabledLabel: null,
    accountNonLockedLabel: null,
    credentialsNonExpiredLabel: null,
    accountNonExpiredLabel: null,
  },
  {
    resetPageFilters() {
      const store = useUsersStore()
      store.filters = createInitialFilterState()
      store.resetBaseFilters()
    },
    copy(item) {
      const obj = {
        enterprises: item.enterprises,
        role: item.role,
      }
      return obj
    },
  },
  {
    fields: [
      {
        id: 'user_name',
        name: 'name',
        label: 'Name',
        size: 12,
        component: 'NInput',
        componentProps: { placeholder: 'Enter name of the user' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'user_email',
        name: 'email',
        label: 'Email',
        size: 12,
        component: 'NInput',
        componentProps: { placeholder: 'Enter official email address' },
        rules: [
          {
            required: true,
            type: 'email',
            trigger: ['blur', 'input'],
          },
          {
            trigger: 'blur',
            remoteValidator: 'isUserEmailUnique',
          },
        ],
      },
      {
        id: 'user_user_name',
        name: 'username',
        label: 'Username',
        size: 12,
        component: 'NInput',
        visible: true,
        componentProps: { placeholder: 'Enter username of the user' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
          {
            trigger: 'blur',
            remoteValidator: 'isUsernameUnique',
          },
        ],
      },
      {
        id: 'user_password',
        name: 'password',
        label: 'Password',
        size: 12,
        component: 'NInput',
        componentProps: { placeholder: 'Enter password of the user' },
        populateOnCreationTime: true,
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'user_enterprises',
        name: 'enterprises',
        label: 'Enterprises',
        size: 12,
        component: 'ArsSmartSelect',
        visible: true,
        submitValueKey: 'externalId',
        componentProps: {
          multiple: true,
          placeholder: 'Select enterprises',
          serviceUri: '/enterprises',
          optionsLabel: 'name',
          clearable: false,
          dxTableName: 'Enterprises',
        },
        rules: [
          {
            required: true,
            type: 'array',
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'user_role',
        name: 'role',
        label: 'Role',
        size: 12,
        component: 'ArsSmartSelect',
        visible: true,
        componentProps: {
          multiple: false,
          placeholder: 'Select role',
          dxTableName: 'Roles',
          serviceUri: '/roles',
          clearable: false,
          optionsLabel: 'name',
        },
        submitValueKey: 'externalId',
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'user_enabled',
        name: 'enabled',
        label: 'Enabled',
        templateLabel: 'enabledLabel',
        size: 6,
        component: 'Span',
        visible: true,
        defaultValue: true,
        componentProps: {},
      },
      {
        id: 'user_account_non_locked',
        name: 'accountNonLocked',
        label: 'Account Non Locked',
        templateLabel: 'accountNonLockedLabel',
        size: 6,
        component: 'Span',
        visible: true,
        defaultValue: true,
        componentProps: {},
      },
      {
        id: 'user_account_non_expired',
        name: 'accountNonExpired',
        label: 'Account Non Expired',
        templateLabel: 'accountNonExpiredLabel',
        size: 6,
        component: 'Span',
        visible: true,
        defaultValue: true,
        componentProps: {},
      },
      {
        id: 'user_credentials_non_expired',
        name: 'credentialsNonExpired',
        label: 'Credentials Non Expired',
        templateLabel: 'credentialsNonExpiredLabel',
        size: 6,
        component: 'Span',
        visible: true,
        defaultValue: true,
        componentProps: {},
      },
      {
        id: 'user_type',
        name: 'type',
        label: 'Type',
        forSubmitOnly: true,
        defaultValue: 'Users',
        visible: false,
        size: 12,
        placeholder: 'Enter type of the user',
        componentProps: {},
      },
    ],
  }
)
